module.exports = __webpack_public_path__ + "static/media/1POLICY20.8ed5fa0e.jpg";